
<template>
  <!-- TODO: 快速滚动 已经停止 页面还在滚动的问题  -->
  <vxe-virtual-tree class="gj-tree-table gj-lrz-table"
    v-on="$listeners"
    :data="tableData"
    height="auto"
    border="inner"
    auto-resize
    highlight-hover-row
    :row-class-name="handleRowClassName"
    :tree-config="treeConfig"
    :scroll-y="{mode: 'wheel',oSize:20}"
    ref="gjTable"
    row-id="rowId"
    v-loading="loading"
    :loading="false"
    :show-footer="showSummary && tableData && tableData.length > 0"
    :footer-method="handleFooterMethod"
    :columns="tableColumn"
    @sort-change="sortChange"
    @scroll="handleTableScroll"
    :sort-config="{trigger: 'cell', defaultSort: handleDefaultSort, remote: true}">
    <!-- 传递插槽  -->
    <template v-for="item in slotArr" v-slot:[item]="props">
      <slot :name="item" v-bind="props"></slot>
    </template>
    <template #top>
      <table-tab ref="tab" v-if="hasTab"
      :columns="tableColumn"
      :slot-group="slotGroup"
      :gj-table="$refs.gjTable"
      >
        <template v-for="item in slotGroup" v-slot:[item]="props">
          <slot :name="item" v-bind="props"></slot>
        </template>
      </table-tab>
    </template>
    <!-- 无数据页面展示 -->
    <template #empty>
      <gj-empty text="暂无数据" />
    </template>
    <!-- 分页器 -->
    <template #pager>
      <div class="gj-table-pagination"
        v-show="pagerConfig.total>0">
        <el-pagination @size-change="pageChange"
          @current-change="pageChange('page')"
          :current-page.sync="pagerConfig.currentPage"
          :page-sizes="pageSizes"
          :page-size.sync="pagerConfig.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagerConfig.total"
          background
          :pager-count="5">
        </el-pagination>
      </div>
    </template>
  </vxe-virtual-tree>
</template>

<script>
import _ from 'lodash'

import { CACHE_PAGINATION_PAGESIZE } from '@/utils/const'
import { defaultVal, isMeaningful, isMeaningless,  } from '@/utils/common'

import TableTab from './gj-table-tab.vue';

export default {
  name:'gj-tree-table',
  components: {
    TableTab
  },
  props:{
    /** 表格数据 */
    list:{
      type:Array,
      default:()=>[],
      require:true
    },
    isSeq:{
      type:Boolean,
      default:true,
    },
    params:{
      type:Object,
      default:()=>{}
    },
    /** 页面加载的loading */
    loading:{
      type:Boolean,
      default:false,
    },
    /** 
     * 配置动态列的数组  配置文档查看官方文档
     * @see {@link https://xuliangzhan_admin.gitee.io/vxe-table/#/grid/api columns}
     */
    columns:{
      type:Array,
      default:()=>[],
      require:true
    },
    /** 是否显示表尾的合计 */
    showSummary:{
      type:Boolean,
      default:false
    },
    /**后台接口 合计的相关数据 */
    summaryObject:{
      type:Object,
      default:()=>{}
    },
    /** 分页器相关配置 */
    pagerConfig:{
      type:Object,
      require:true,
      default:()=>{
        return{
          currentPage:1,
          pageSize:20,
          total:0
        }
      }
    },
    /** 分页数组配置 */
    pageSizes:{
      type:Array,
      default:()=>{
        return [20,50,100,200,500]
      }
    },
    /** 排序配置 */
    defaultSort: {
      type: Object,
      default: null
    },
    // 树
    treeConfig: {
      type: Object,
      default: () => { return {children: 'items',iconOpen: 'el-icon-arrow-down', iconClose: 'el-icon-arrow-right'}}
    },
    selection: {
      type: Boolean,
      default: false
    },
  },
  filters: {
    proxyDefaultShow (value, defaultValue, row) {
      if (isMeaningless(value) && typeof defaultValue === 'function' && isMeaningful(row)) {
        return defaultValue(row)
      }
      let v = '-'
      if (defaultValue !== null && defaultValue !== undefined) {
        v = defaultValue
      }
      return defaultVal(value, v)
    }
  },
  data(){
    return {
      tableColumn: [], // 动态列的配置数据
      slotArr:[],     // 注册插槽 传递插槽,
      tableData:[],
      slotGroup: [],
      sortOption:null,
      hasTab: this.columns.some(v => v.group),
    }
  },
  created(){
    this.handleSlots(this.columns)
    this.handleFormatter(_.cloneDeep(this.columns))
  },
  watch:{
    columns : {
      handler(newVal,oldVal){
        this.handleFormatter(_.cloneDeep(newVal))
        this.handleSlots(newVal)
        this.$refs?.tab?.handleChange();
      },
      immediate:true
    },
    list:{
      handler(newVal,oldVal){
        this.handleData(newVal);
        this.$refs?.tab?.handleChange();
      },
      immediate:true
    }
  },
  methods:{
    /**追加rowId 用来扩展class */
    handleData(data){
      this.tableData = data.map((v,i)=>{
        v.rowId = `rId_${i+30}` 
        return v
      })
    },
    /**
     * 遍历出 需要在vxe-grid注册的插槽  传递插槽
     * @param { arrry } columns -表格列的配置的数据
     * @returns {Arrry} 返回插槽数据列表
     */
    handleSlots(columns){
      const slots = columns.filter(v=>v.slots).map(v=>v.slots);
      this.slotGroup = slots.map(v => v.group).filter(v => v);
      this.slotArr = [
        ...slots.map(v=>v.default).filter(v=>v),
        ...slots.map(v=>v.header).filter(v=>v),
      ]
    },
    /**
     * 处理需要格式化的内容 并处理序号添加的问题
     * @param { arrry } columns -表格列的配置的数据
     * @returns {Arrry} 返回加上格式化配置函数的配置数据
     */
    handleFormatter(columns){
      columns.map(v=>{
        if(v.suffix){
          v.formatter = this.handleSuffix(v.suffix)
        }
        if(v.prefix){
          v.formatter = this.handlePrefix(v.prefix)
        }
      })
      this.handleAddIconCol(columns)
      if(this.isSeq && !columns.some(v=>v.type === 'seq')){
        columns.unshift({
          id: 'index',
          field: 'index',
          title: '序号',
          // type: 'seq',
          align:'center',
          width: '55px',
          fixed: 'left',
          checked:true
        })
      }
      this.tableColumn = this.handleColumnNoChecked(columns)
      //列改变后，手动更新表头排序css效果
      if(this.$refs.gjTable&&this.sortOption){
        setTimeout(()=>{
          this.$refs.gjTable.sort(this.sortOption.field||this.sortOption.property||'',this.sortOption.order)
        },100)
      }
    },
    //排序改变事件、抓取设置排序需要的参数
    sortChange({ column, property, order }){
      this.sortOption = { field:column.field, property:property, order:order };
    },
    /** 追加 iconCol */
    handleAddIconCol(columns){
      columns.unshift({
        id: 'expand_icon',
        field: 'expand_icon',
        width: '50px',
        fixed: 'left',
        checked:true,
        treeNode: true,
      })
    },
    /** 过滤掉 未选中的  配合自定义列使用 追加的col 需要默认加上checked = true 还要过滤 */
    handleColumnNoChecked(columns=[]){
      return columns.filter(v=> 
        v.checked && 
        (isMeaningless(v.exist) || v.exist) &&
        (this.hasTab ? v.field : true) // 过滤特殊字段的 tab
      )
    },
    /** 
     * 处理后缀 柯里化 TODO: 根据需求扩展更多
     * @param {String} symbol '后缀的标识'
    */
    handleSuffix(symbol){
      return function({cellValue}){
        return `${cellValue}${symbol}`
      }
    },
    /** 
     * 处理前缀 柯里化 TODO: 根据需求扩展更多
     * @param {String} symbol '后缀的标识'
    */
    handlePrefix(symbol){
      return function({cellValue,row}){
        return `${row[symbol]}${cellValue}`
      }
    },
    /** 
     * 给展开的子项添加 一个className 请求到后台 需手动在 在数组对象里面 添加rowId的属性 来区别 展开项的id
     * @see {@link https://xuliangzhan_admin.gitee.io/vxe-table/#/grid/api params row-class-name}
     */
    handleRowClassName({ row, rowIndex, $rowIndex }){
      if(row.rowId.startsWith('row_')){
        return 'expand_row'
      }
    },
    /** */
    pageChange (page) {
      // 存储分页缓存
      this.$cache.setCache(CACHE_PAGINATION_PAGESIZE.call(this), { pageSize: this.pagerConfig.pageSize })
      this.$emit('page-change', page)
    },
    /**
     * 表尾 统计相关数据的展示 加上前缀后缀处理
     * 返回一个二维数据 
     */ 
    handleFooterMethod({columns, data}){
      // 如果后台已经返回 合计的结果
      if( isMeaningful(this.summaryObject)){
        const arr = this.tableColumn.map(v=>{
          if(v.summary){
            let summaryNum = this.summaryObject[v.id] 
            if(isMeaningful(summaryNum)){
              if(v.suffix){
                summaryNum = `${summaryNum}${v.suffix}`
              }
              // if(v.prefix){
              //   summaryNum = `$${summaryNum}`
              // }
            }
            v.summaryNum = summaryNum
          }
          return v.summaryNum
        })
        arr[0]= '总计'
        return [arr]
      }else{
        // TODO: 等前端手动计算和累加
        [[]]
      }
    },
    /**
     * 处理排序
     */
    handleDefaultSort(){
      if (this.defaultSort) {
        return {
          field: this.defaultSort.prop,
          order: (this.defaultSort.order || 'descending').replace('ending', '')
        }
      }
      return null
    },

    handleTableScroll(e) {
      this.$refs.tab?.handleScroll(e);
    }
  }
}
</script>

<style lang="scss">
.gj-lrz-table{
  td.vxe-body--column {
    padding: 4px 0 !important;
    .vxe-cell {
      max-height: 48px;
      // line-height: 48px;
       div {
        line-height: 16px;
      }
    }
  }
  .vxe-table--render-default.vxe-editable.size--small .vxe-body--column, .vxe-table--render-default.size--small .vxe-header--column.col--ellipsis, .vxe-table--render-default.size--small .vxe-body--column.col--ellipsis, .vxe-table--render-default.size--small .vxe-footer--column.col--ellipsis{
    height: 48px;
  }
  .vxe-table--empty-placeholder{
    align-items: flex-start !important;
    padding-top: 20px;
  }
  .vxe-table--empty-content {
    .gj-empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        max-width: 200px;
      }
    }
  }
  .gj-table-pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background-color: #fff;
    padding-top: 12px;
  }
}
.gj-tree-table {
  height: 100%;
  .expand_row {
    background-color: #f7f8fa;
    td:nth-child(1){
      border-left: 3px solid #1F6EEF;
    }
  }
  .vxe-table--header-wrapper{
    background-color: #fff !important;
    .vxe-header--row{
      .vxe-header--column{
        .vxe-cell{
          display: flex;
          align-items: center;
          font-size: 12px;
          .vxe-cell-help-icon{
            order: 2;
            margin-left: 0.2em;
          }
          .vxe-cell-help-icon::before{
            width: 14px;
            height: 14px;
            border:1px solid #606266;
            transform: none;
          }
          .vxe-cell-help-icon::after{
            color: #606266;
            transform: rotate(-10deg) scale(0);
          }
          .vxe-cell--title{
            order: 1;
            // text-align: center;
          }
          .vxe-cell--sort{
            order: 3;
          }
        }
      }
    }
  }
  .table-tree-icon{
    display: none;
    margin-left: 0.4rem;
    cursor: pointer;
  }
  .vxe-body--row{
    .vxe-body--column:hover{
        .table-tree-icon{
          display:inline-block;
        }
    }
  }
}

</style>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
.gj-tree-table{
  /deep/ .col--last{
    .vxe-cell{
      padding-left: 16px;
    }
  }
  /deep/ .vxe-table--footer-wrapper{
    color: #333;
  }
  /deep/.gj-help--icon{
    .gj-icon{
      font-size: 13px;
      color: #666;
    }
  } 
  /deep/ .vxe-table--border-line{
    border: 1px solid #d8dadd !important;
  }
  ::v-deep .vxe-table  .vxe-header--row {
    height: 40px !important;
    background: $gj-tableHeader-color;
  }
  ::v-deep .vxe-table  .vxe-footer--row{
    background: $gj-tableHeader-color;
  }
  /deep/ .col--right{
    .vxe-cell{
      justify-content: flex-end;
    }
  }

  /deep/ .vxe-table--render-default .vxe-table--fixed-left-wrapper.scrolling--middle {
    box-shadow: 4px 0px 6px -2px rgba($color: #000000, $alpha: 0.12);
  }
  /deep/ .vxe-table--render-default .vxe-table--fixed-right-wrapper.scrolling--middle{
    box-shadow: -4px 0 6px -2px rgba($color: #000000, $alpha: 0.12);
  }
  /deep/ .vxe-table--footer{
    height: 40px;
  }
  /deep/ .vxe-table--render-default .vxe-table--footer-wrapper{
    background-color: #e8eaec;
  }
  /* 字体大小 */
  /deep/ .vxe-table.size--small {
    font-size: 12px;
  }
  /deep/ .el-pagination{
    font-weight: 500;
  }
  /deep/ .vxe-table--body .vxe-body--row.row--hover {
    background-color: $gj-hover-color;
  }
}
  

</style>
